import React, { useState, useContext } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import HttpClient from '../../services/HttpClient'

import FormErrors from '../../components/FormErrors/FormErrors'
import Button from '../../components/Button/Button'
import AppContext from '../../contexts/AppContext'
import '../../styles/parchment-page.css'

export default function () {
  const navigate = useNavigate()
  const { user, setUser } = useContext(AppContext)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState([])

  // Hooks always run before any early return (avoids crash after successful login)
  if (user) {
    return <Navigate to="/" />
  }

  const onSubmit = async (event) => {
    event.preventDefault()

    setErrors([])
    let _errors = []

    if (!email) _errors.push('Email is required')
    if (!password) _errors.push('Password is required.')

    if (_errors.length) return setErrors(_errors)
    try {
      const data = {
        email,
        password,
      }

      const response = await HttpClient().post('/api/v1/user/login', data)
      setUser(response.data.user)
      localStorage.setItem('token', response.data.token)
      navigate('/')
    } catch (e) {
      // HttpClient rejects a flat { message, status } — not axios error.shape
      const msg =
        e?.message ||
        e?.response?.data?.message ||
        'No se pudo iniciar sesión. Comprueba que el servidor esté en marcha.'
      setErrors([msg])
    }
  }

  return (
    <div className="page parchment-scope">
      <span className="page__eyebrow">門 · Acceso</span>
      <h1 className="page__title">Entrar</h1>
      <div className="page__panel">
        <form onSubmit={onSubmit} className="form">
          {!!errors.length && <FormErrors errors={errors} />}

          <div className="form__group">
            <label className="form__label">Email</label>
            <input type="text" className="form__input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="form__group">
            <label className="form__label">Contraseña</label>
            <input type="password" className="form__input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          <Button>Entrar</Button>
        </form>
      </div>
    </div>
  )
}
